module.exports = "pegasus/assets/theme4/medium/8.jpg";